import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPauseCircle } from '@fortawesome/free-solid-svg-icons'; // FA5 name for fa-circle-pause
import OrderDetailModalParent from 'components/orderdetail/OrderDetailModalParent';
import AddOrderModal from 'components/patient/view-patient/AddOrderModal';
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { formatHoldQty, hasHoldQty } from 'helpers/holdQty';
import { Link } from 'react-router-dom';

// The order as the order detail drawer expects it. PatientView uses it too, to
// open an order straight from the hold list.
export const toOrderOriginal = data => ({
    patient: data.patient_lastname + ", " + data.patient_firstname,
    ordertype: data.order_type,
    deliverydatetime: data.delivery_date != null ? moment(data.delivery_date).format('MM/DD/YY') : null,
    refillrequest: data.refill_request,
    createdby: data.created_by_username,
    createddate: data.created != null ? moment(data.created).format('MM/DD/YY - hh:mm A') : null,
    orderstatus: data.order_status,
    rxnumber: data.pharmacy_order_id,
    qty: data.drug_qty,
    drug: data.drug,
    orderid: data.id,
    notesObj: data.notes,
    internalNotesObj: data.internal_notes,
    documents: data.documents,
    is_billing_issue: data.is_billing_issue,
    is_loansupplies: data.is_loansupplies,
    is_pa: data.is_pa,
    deliveryOn: data.delivery_type,
    parentId: data.patient_id,
    patientModalData: data.patient,
    order_status_log: data.logs,
    pickup_store_id: data.pickup_store_id,
    billing_date: data.billing_date,
    billing_status: data.billing_status,
    billing_timestamp: data.billing_timestamp,
    pv1_timestamp: data.pv1_timestamp,
    pv2_timestamp: data.pv2_timestamp,
    filling_timestamp: data.filling_timestamp,
    is_callback: data.is_callback,
    is_pharmacy_attention: data.is_pharmacy_attention,
    pharmacy_attention_id: data.pharmacy_attention_id,
    callback_master_id: data.callback_master_id,
    callback_number: data.callback_number,
    pharmacy_attention_reason_name: data.pharmacy_attention_reason_name,
    callback_reason_name: data.callback_reason_name,
    reasonLabels: data.callback_reason_name || data.pharmacy_attention_reason_name,
    holdreason_id: data.holdreason_id,
    holdreason_text: data.holdreason_text,
    hold_date: data.hold_date,
    hold_by_username: data.hold_by,
    // Units held on the Rx (null = not recorded). `qty` above is the order's drug_qty.
    hold_qty: data.hold_qty ?? null,
    is_hold: data.is_hold,
})

const MedCard = (props) => {
    const [showModal, setShowModal] = useState(false);
    const data = props.data;
    const [original, setOriginal] = useState({})

    useEffect(() => {
        setOriginal(toOrderOriginal(data))
    }, [data])

    const uniqueId = `collapseDetails-${Number(original.parentId)}-${Number(original.orderid)}`;
    const triggerModal = () => {
        setShowModal(true);
    }
    return (
        <>
            {showModal && <OrderDetailModalParent show={showModal} filteredData={original} setRefresh={setOriginal} handleClose={() => setShowModal(false)} />}
            {/* No border or background of its own: the rounded row in PatientCard is the card. */}
            <div className="card rounded-2 border-0 bg-transparent">
                <div
                    className='card-header d-flex align-items-center gap-1 px-1'
                    style={{ paddingTop: 2, paddingBottom: 2 }}
                >
                    {/* Hold icon sits before the drug name */}
                    {Number(original.is_hold) === 1 && (
                        <FontAwesomeIcon
                            icon={faPauseCircle}
                            title={hasHoldQty(original.hold_qty) ? `On hold · Qty ${formatHoldQty(original.hold_qty)}` : "On hold"}
                            className="flex-shrink-0"
                            style={{ color: 'var(--falcon-danger)', fontSize: '0.875rem' }}
                        />
                    )}
                    <a
                        className="flex-grow-1"
                        data-bs-toggle="collapse"
                        data-bs-target={`#${uniqueId}`}
                        aria-expanded="false"
                        aria-controls={uniqueId}
                    >
                        {original.drug ? original.drug : "New Patient"}
                    </a>
                    <Link className="flex-shrink-0" state={{ original }}>
                        <FontAwesomeIcon className="text-disable" icon="edit" onClick={triggerModal} />
                    </Link>
                </div>
                <div className="collapse card-body p-0" id={uniqueId}>
                    <div className="px-1 py-1" style={{ fontSize: "12px", color: "#555", lineHeight: "1" }}>
                        <p style={{ margin: "5px 0" }}>{original.time}</p>
                        <p style={{ margin: "5px 0" }}>{'Morning/Evening'}</p>
                        <p style={{ margin: "5px 0" }}>{original.createddate}</p>
                        <p style={{ margin: "5px 0" }}>{original.createdby}</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MedCard
